module.exports = __webpack_public_path__ + "img/user.2d92674c.svg";